export var Key;
(function (Key) {
    Key["CONTRACT_OWNER"] = "CONTRACT_OWNER";
    Key["PAYMENT_ACTION"] = "PAYMENT_ACTION";
    Key["MAKER_DEPOSIT"] = "MAKER_AVAILABLE_BALANCE";
    Key["ORDER_STATE"] = "ORDER_STATE";
    Key["NEW_ACTION"] = "NEW_ACTION";
    Key["HANDLED_ACTION"] = "HANDLED_ACTION";
    Key["ORDER_OWNER_INDEX"] = "ORDER_OWNER_INDEX";
    Key["ORDER_DATE_INDEX"] = "ORDER_DATE_INDEX";
    Key["ORDER_BEST_INDEX"] = "ORDER_BEST_INDEX";
    Key["ORDER_ACTIVE_INDEX"] = "ORDER_ACTIVE_INDEX";
    Key["ORDER_CLOSED_INDEX"] = "ORDER_CLOSED_INDEX";
    Key["ORDER_RATE_INDEX"] = "ORDER_RATE_INDEX";
    Key["REQUEST_STATE"] = "REQUEST_STATE";
    Key["REQUEST_BY_ORDER_INDEX"] = "REQUEST_BY_ORDER_INDEX";
    Key["REQUEST_BY_MAKER_INDEX"] = "REQUEST_BY_MAKER_INDEX";
    Key["REQUEST_REVERSE_INDEX"] = "REQUEST_REVERSE_INDEX";
    Key["INCREMENT_INDEX"] = "INCREMENT_INDEX";
    Key["BTC_NONCE"] = "BTC_NONCE";
    Key["L1_TX_INFO"] = "L1_TX_INFO";
})(Key || (Key = {}));
export var ORDER_ACTIVITY_STATUS;
(function (ORDER_ACTIVITY_STATUS) {
    ORDER_ACTIVITY_STATUS["ACTIVE"] = "ACTIVE";
    ORDER_ACTIVITY_STATUS["DISABLED"] = "DISABLED";
})(ORDER_ACTIVITY_STATUS || (ORDER_ACTIVITY_STATUS = {}));
export var REQUEST_EXECUTION_STATUS;
(function (REQUEST_EXECUTION_STATUS) {
    REQUEST_EXECUTION_STATUS["PENDING"] = "PENDING";
    REQUEST_EXECUTION_STATUS["EXECUTED"] = "EXECUTED";
    REQUEST_EXECUTION_STATUS["FAILED"] = "FAILED";
})(REQUEST_EXECUTION_STATUS || (REQUEST_EXECUTION_STATUS = {}));
export var PUBLIC_METHODS;
(function (PUBLIC_METHODS) {
    PUBLIC_METHODS["DEPOSIT"] = "DEPOSIT";
    PUBLIC_METHODS["WITHDRAW"] = "WITHDRAW";
    PUBLIC_METHODS["CREATE_ORDER"] = "CREATE_ORDER";
    PUBLIC_METHODS["CANCEL_ORDER"] = "CANCEL_ORDER";
    PUBLIC_METHODS["REQUEST_EXECUTION"] = "REQUEST_EXECUTION";
    PUBLIC_METHODS["CHANGE_CONTRACT_OWNER"] = "CHANGE_CONTRACT_OWNER";
    PUBLIC_METHODS["HANDLE_FALLBACK"] = "HANDLE_FALLBACK";
})(PUBLIC_METHODS || (PUBLIC_METHODS = {}));
export const FEE = {
    CREATE_ORDER: 400000n,
    CANCEL_ORDER: 400000n,
    DEPOSIT: 1000000n,
    WITHDRAW: 50000n,
    HANDLE_EXECUTION_REQUEST: 1300000n,
};
export var BtcAddressType;
(function (BtcAddressType) {
    BtcAddressType["p2pkh"] = "p2pkh";
    BtcAddressType["p2sh"] = "p2sh";
    BtcAddressType["p2wpkh"] = "p2wpkh";
    BtcAddressType["p2wsh"] = "p2wsh";
    BtcAddressType["p2tr"] = "p2tr";
})(BtcAddressType || (BtcAddressType = {}));
const BTC_MAIN_NET = {
    bech32: 'bc',
    scriptHash: 0x05,
    publicKeyHash: 0x00,
};
const BTC_TEST_NET = {
    bech32: 'tb',
    scriptHash: 0xc4,
    publicKeyHash: 0x6f,
};
const LTC_MAIN_NET = {
    bech32: 'ltc',
    scriptHash: 0x32,
    publicKeyHash: 0x30,
};
const LTC_TEST_NET = {
    bech32: 'tltc',
    scriptHash: 0x3a,
    publicKeyHash: 0x6f,
};
const DOGE_MAIN_NET = {
    bech32: '',
    scriptHash: 0x16,
    publicKeyHash: 0x1e,
};
const DOGE_TEST_NET = {
    bech32: '',
    scriptHash: 0xc4,
    publicKeyHash: 0x71,
};
export const BtcLikeNetworkParams = {
    btc: BTC_MAIN_NET,
    tbtc: BTC_TEST_NET,
    ltc: LTC_MAIN_NET,
    tltc: LTC_TEST_NET,
    dog: DOGE_MAIN_NET,
    tdog: DOGE_TEST_NET,
};
export const OrderBatchFields = [
    'baseAmount',
    'l1Amount',
    'baseRecipient',
    'minL1Amount',
];
export var SWAP_ACTION_STATUS;
(function (SWAP_ACTION_STATUS) {
    SWAP_ACTION_STATUS["SUCCESS"] = "SUCCESS";
    SWAP_ACTION_STATUS["RETRY"] = "RETRY";
    SWAP_ACTION_STATUS["FALLBACK"] = "FALLBACK";
})(SWAP_ACTION_STATUS || (SWAP_ACTION_STATUS = {}));
